import { Navbar } from "@/components/Navbar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";

const webinars = [
  {
    id: 1,
    title: "Digital Marketing Trends 2024",
    date: "March 25, 2024",
    description: "Join us to explore the latest trends in digital marketing and how to leverage them for your business.",
    imageUrl: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070&auto=format&fit=crop",
    registrationLink: "#"
  },
  {
    id: 2,
    title: "SEO Masterclass",
    date: "April 2, 2024",
    description: "Learn advanced SEO techniques to improve your website's visibility and rankings.",
    imageUrl: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop",
    registrationLink: "#"
  },
  {
    id: 3,
    title: "PPC Campaign Optimization",
    date: "April 15, 2024",
    description: "Discover strategies to optimize your PPC campaigns for better ROI.",
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
    registrationLink: "#"
  }
];

const Webinars = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="py-20 px-4 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl font-bold mb-6 text-gray-900">
            Upcoming Webinars
          </h1>
          <p className="text-xl text-gray-600">
            Join our expert-led webinars to stay ahead in digital marketing
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {webinars.map((webinar) => (
            <Card key={webinar.id} className="overflow-hidden hover:shadow-lg transition-shadow">
              <div className="aspect-video relative overflow-hidden">
                <img 
                  src={webinar.imageUrl} 
                  alt={webinar.title}
                  className="object-cover w-full h-full hover:scale-105 transition-transform duration-300"
                />
              </div>
              <CardHeader>
                <div className="text-sm text-muted-foreground mb-2">{webinar.date}</div>
                <CardTitle className="line-clamp-2">{webinar.title}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-muted-foreground line-clamp-3">
                  {webinar.description}
                </p>
                <Button className="w-full">Register Now</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Webinars;